import { Modal, Button, Spinner } from "react-bootstrap";
import config from "../../config";
import { useState } from "react";

const ConfirmModal = ({ open, setOpen, expenseId, fetchExpenses }) => {
  const [loading, setLoading] = useState(false);

  const deleteExpense = async (expenseId) => {
    try {
      setLoading(true);
      let res = await fetch(`${config.newApiGateway}/expenses/expenses`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          type: "delete",
          billId: expenseId,
        }),
      });
      res = await res.json();
      console.log("response", res);
      if (res.code === "SUCCESS") {
        alert(res.message);
        setOpen(false);
        fetchExpenses();
      }
    } catch (err) {
      console.error("Error", err);
    } finally {
      setLoading(false);
    }
  };
  const handleYes = () => {
    deleteExpense(expenseId);
  };
  return (
    <Modal show={open} onHide={() => setOpen()} centered>
      <Modal.Body
        style={{
          padding: "24px",
        }}
      >
        Are you sure to delete this Expense?
        <div
          style={{
            marginTop: "20px",
            textAlign: "right",
          }}
        >
          <Button
            variant="danger"
            style={{
              width: "100px",
            }}
            onClick={handleYes}
          >
            Yes
            {loading && <Spinner size="sm" color="#fff" />}
          </Button>
          <Button
            variant=""
            style={{
              width: "100px",
              marginLeft: "8px",
            }}
            onClick={() => setOpen()}
          >
            No
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmModal;
